<template>
    <div id="x-footer">
        <!--页尾区域-->
        <div class="x-wrap-footer z-index-hig" id="x-wrap-footer">
            <div class="footer-con">
                <div class="company x-flow from-top">
                    <h3 class="tit">Company</h3>
                    <ul class="list com-list">
                        <li>
                            <router-link @click.native.prevent="redirectTo({
                              name: 'join', params: {
                                 activeTop: [1,1],activeSide:[1], curTime: Date.now()
                              }})" :to="{
                              name: 'about', params: {
                                 activeTop: [1,1],activeSide:[1], curTime: Date.now()
                              }}">Who	we	are
                            </router-link>
                        </li>
                        <li>
                            <router-link @click.native.prevent="redirectTo({
                              name: 'join', params: {
                                 activeTop: [1,3],activeSide:[3], curTime: Date.now()
                              }})" :to="{
                              name: 'about', params: {
                                activeTop:  [1,3],activeSide:[3], curTime: Date.now()
                              }}">What	we	do
                            </router-link>
                        </li>
                        <li>
                            <router-link @click.native.prevent="redirectTo({
                              name: 'join', params: {
                                 activeTop: [1,6],activeSide:[6], curTime: Date.now()
                              }})" :to="{
                              name: 'about', params: {
                                 activeTop: [1,6],activeSide:[6], curTime: Date.now()
                              }}">Corporate Responsibility
                            </router-link>
                        </li>
                        <li>
                            <router-link @click.native.prevent="redirectTo({
                              name: 'join', params: {
                                 activeTop: [1,7],activeSide:[7], curTime: Date.now()
                              }})" :to="{
                              name: 'about', params: {
                                 activeTop: [1,7],activeSide:[7], curTime: Date.now()
                              }}">Contact Information
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="join-us x-flow from-top">
                    <h3 class="tit">Join Us</h3>
                    <ul class="list join-us-list">
                        <li>
                            <router-link @click.native.prevent="redirectTo({
                              name: 'join', params: {
                                 activeTop: [5,2],activeSide:[2], curTime: Date.now()
                              }})" :to="{
                              name: 'join', params: {
                                 activeTop: [5,2],activeSide:[2], curTime: Date.now()
                              }}">Social Recruitment
                            </router-link>
                        </li>
                        <li>
                            <router-link @click.native.prevent="redirectTo({
                              name: 'join', params: {
                                 activeTop: [5,3],activeSide:[3], curTime: Date.now()
                              }})" :to="{
                              name: 'join', params: {
                                 activeTop: [5,3],activeSide:[3], curTime: Date.now()
                              }}">Campus Recruiting
                            </router-link>
                        </li>
                    </ul>
                </div>
                <!--<div class="legal-info x-flow from-top">
                    <h3 class="tit">Legal Information</h3>
                    <ul class="list legal-info-list">
                        <li>
                            <router-link to="">Service Agreement</router-link>
                        </li>
                        <li>
                            <router-link to="">Privacy Policy</router-link>
                        </li>
                        <li>
                            <router-link to="">Intellectual Property</router-link>
                        </li>
                    </ul>
                </div>-->
                <div class="contact-us x-flow from-top">
                    <ul class="contact-us-list x-clear">
                        <li>
                            <router-link to=""
                                         @click.native="winLocateTo('https://xhorseglobal.blogspot.com/')">
                                <i class="icon i-qq"></i></router-link>
                        </li>
                        <li>
                            <router-link to=""
                                         @click.native="winLocateTo('https://www.facebook.com/XhorseLocksmithClub')"><i
                                    class="icon i-wechat"></i></router-link>
                        </li>
                        <li>
                            <router-link to=""
                                         @click.native="winLocateTo('https://twitter.com/XhorseGlobal')"><i
                                    class="icon i-weibo"></i></router-link>
                        </li>
                        <li>
                            <router-link to=""
                                         @click.native="winLocateTo('https://www.youtube.com/channel/UCGDrp9nLoOfaMTbEpfQeZ-g')">
                                <i
                                        class="icon i-twitter"></i></router-link>
                        </li>
                    </ul>
                    <div class="where-info x-clear">
                        <ul>
                            <li>
                                <!--Room 2009-2011, Changhong Technology Building, 12th Tech Road South, Nanshan District, Shenzhen City.-->
                                Floor 28, Block A, Building NO.6, International Innovation Valley, Nanshan District, Shenzhen City.
                            </li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                </div>
                <div class="footer-area">
                    <div class="copy-right">Copyright © 2020. All rights reserved.</div>
                    <br>
                    <div class="icp-no">
                        <a href="https://beian.miit.gov.cn/" target="_blank">[粤ICP备17128314号]</a>
                    </div>
                    <div class="public-network">
                        <a target="_blank"
                           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502006534">
                            <img :src="nationImage" title="" />
                            <p>粤公网安备 44030502006534号</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!--页尾区域-->
    </div>
</template>
<script>
	import nationImage from '../../assets/resource/images/common/nation.png';
	export default {
		name   : 'x-footer',
		prop   : ['path', 'activeSideIndex'],
		data(){
			return {
				nationImage: nationImage
			};
		},
		methods: {
			winLocateTo(url){
				//window.location.href = url;
				window.open(url, '_blank')
			},
			redirectTo(data){
				const _this = this;
				//console.log("redirectTo[1]", data.params.activeSide)
				_this.$router.push(data);
				_this.$emit('go', {type: 'side', val: data.params.activeSide});

                /*console.log("redirectTo[2]", _this.$footActiveSide)*/
			},
			beforeRoute(){
				const _this = this;
				if (_this.$route.params) {
					var parmas = _this.$route.params;
					//console.log(parmas)
				}
			}
		},
		watch  : {
			$route: {
				handler: 'beforeRoute',
				deep   : true
			}
		},
		created(){
			const _this = this;
			_this.beforeRoute();
		},
		beforeRouteLeave (to, from, next) {
            if(['/software','/xhorseIM','/download'].includes(to.path)){
                next(true)
                return
             }
			const _this = this;
			//console.log("ssss", to, from)
			var data    = {
				side: _this.activeIndex.side,
				top : _this.activeIndex.top,
			};

			if (to.params.hasOwnProperty('activeTop') && to.params.hasOwnProperty('activeSide')) {
				data.side = to.params.activeSide;
				data.top  = to.params.activeTop;
			}

			_this.$store.commit('setActivePath', {
				type: 'all',
				val : data
			});
			next(true)
		}
	}
</script>
<style scoped="">
    @import "../../assets/css/footer.css";
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/footer.vue